import {mergeMap, Observable, retryWhen, throwError, timer} from "rxjs";

export function retryBackoff(maxRetries = 2, initialDelayMs = 300) {
  return <T>(src: Observable<T>) =>
    src.pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((err, i) => {
            if (i >= maxRetries) return throwError(() => err);
            const delay = initialDelayMs * Math.pow(2, i); // 300, 600, 1200...
            return timer(delay);
          })
        )
      )
    );
}
